import { SelectOption } from './Helpers';

export default function enumToSelectOptions(theEnum: Record<string, string>, prefix = ''): SelectOption[] {
	return Object.values(theEnum).map(key => ({
		label: prefix + key,
		value: key,
	}));
}
